import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { articleImageMap } from '@/mocks/article-images';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const imageUrl = articleImageMap[article.slug] || '';

  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group transition-colors hover:border-primary-200/60">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="relative w-full aspect-video overflow-hidden">
          <img
            src={imageUrl}
            alt={article.title}
            title={`${article.title} - 安全指南`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <Link
            to={`/category/${article.category}`}
            className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            {article.categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{article.date}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-400">{article.readTime} 分钟阅读</span>
        </div>
        <Link to={`/article/${article.slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
          {article.excerpt}
        </p>
      </div>
    </article>
  );
}